import administracao from '@/router/administracao/index'
import almoxarifado from '@/router/almoxarifado/index'
import ambulatorio from '@/router/ambulatorio/index'
import apac from '@/router/apac/index'
import atencaoBasica from '@/router/atencao-basica/index'
import bpa from './bpa'
import cadastro from '@/router/cadastro/index'
import exameImagem from '@/router/exame-imagem/index'
import exameLaboratorial from '@/router/exame-laboratorial/index'
import farmacia from '@/router/farmacia/index'
import imunizacao from '@/router/imunizacao'
import integracao from '@/router/integracao/index'
import manutencao from '@/router/manutencao/index'
import painelSenha from '@/router/painel-senha/index'
import parametrizacao from '@/router/parametrizacao/index'
import prontoAtendimento from '@/router/pronto-atendimento/index'
import raas from './raas'
import regulacao from '@/router/regulacao/index'
import relatorios from '@/router/relatorios/index'
import transportePaciente from '@/router/transporte-paciente/index'
import webService from './web-service'

export default  [
    {
        path: '/',
        meta: { requiresAuth: true },
        component: () => import('@/components/base/RouterViewWrapper'),
        redirect: 'dashboard',
        children: [
            {
                name: 'dashboard',
                path: 'dashboard',
                component: () => import('@/views/Dashboard.vue'),
            },
            {
                name: 'lotacao',
                path: 'lotacao',
                meta: { layout: 'empty' },
                component: () => import('@/views/administracao/autenticacao/Lotacao.vue'),
            },
            ...administracao,
            ...almoxarifado,
            ...ambulatorio,
            ...apac,
            ...atencaoBasica,
            ...bpa,
            ...cadastro,
            ...exameImagem,
            ...exameLaboratorial,
            ...farmacia,
            ...imunizacao,
            ...integracao,
            ...manutencao,
            ...painelSenha,
            ...parametrizacao,
            ...prontoAtendimento,
            ...raas,
            ...regulacao,
            ...relatorios,
            ...transportePaciente,
            ...webService,
        ],
    }
]